export type OutOfStockEntry = {
  variantId: number;
  requestedQuantity: number;
  availableQuantity: number;
};

/**
 * Thrown when the Made add-to-cart mutation rejects items because the
 * requested quantity exceeds available stock. The `oversold` payload carries
 * per-variant remaining counts so the UI can render an actionable message.
 */
export class OutOfStockError extends Error {
  oversold: OutOfStockEntry[];

  constructor(oversold: OutOfStockEntry[]) {
    super("Some items are out of stock for the requested quantity.");
    this.name = "OutOfStockError";
    this.oversold = oversold;
  }
}
